import { Navigate } from "react-router-dom";

//Dashboard
import DashboardCrm from "../pages/Dashboard";

//pages
import ComingSoon from '../pages/Pages/ComingSoon/ComingSoon';
import Settings from '../pages/Pages/Profile/Settings/Settings';

import HomeLanding from '../pages/Home_Landing'

//login
import ForgetPasswordPage from "../pages/Authentication/ForgetPassword";
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";

// User Profile

import Profile from "pages/User/Profile";
import UserProfile from "../pages/Authentication/user-profile";

import RoleList from "pages/User/Role";
import UserList from "pages/User/User";
import AINewsList from "pages/News/AINews";
import ImageBasedNewsList from "pages/News/GovernmentNews/ImageBasedNews";
import LogoBasedNewsList from "pages/News/GovernmentNews/LogoBasedNews";
import MyNewsList from "pages/News/MyNews";
import BoostingNewsList from "pages/News/BoostingNews";
import RealTimeNewsList from "pages/News/RealTimeNews";
import AIArticleGeneration from "pages/News/AIArticleGeneration";
import RecommendRealTimeKeywordList from "pages/RecommendKeyword/RealTimeKeyword";
import RecommendPopularKeywordList from "pages/RecommendKeyword/PopularKeyword";
import ImageRepository from "pages/ImageRepository";
import MyImage from "pages/ImageRepository/MyImage";
import PublicImage from "pages/ImageRepository/PublicImage";



const ROUTES = {
  LOGIN: '/login',
  HOME: '/',
  DASHBOARD: '/dashboard',

  PROFILE: '/profile',
  PROFILE_SETTING: '/pages-profile-settings',

  USER_LIST: '/user/list',
  USER_ROLE: '/user/role',
  USER_PROFILE: '/user/profile',
  MANAGEMENT_PROXY: '/user/proxy',

  AI_NEWS: '/ai-news',
  GOVERNMENT_IMAGE_BASED_NEWS: '/government-news/image-based-news',
  GOVERNMENT_LOGO_BASED_NEWS: '/government-news/logo-based-news',
  BOOSTING_NEWS: '/boosting-news',
  REAL_TIME_NEWS: '/real-time-news',
  MY_NEWS: '/my-news',
  RECOMMEND_REAL_TIME_KEYWORD: '/recommend/real-time-keyword',
  RECOMMEND_POPULAR_KEYWORD: '/recommend/popular-keyword',
  AI_ARTICLE_GENERATION: '/ai-article-generation',
  IMAGE_REPOSITORY: '/image-repository',

  MY_IMAGES: '/image-repository/my-images',
  PUBLIC_IMAGES: '/image-repository/public-images',
}

const authProtectedRoutes = [
  { path: ROUTES.DASHBOARD, component: <DashboardCrm /> },

  { path: ROUTES.PROFILE_SETTING, component: <Settings /> },
  { path: ROUTES.PROFILE, component: <UserProfile /> },

  { path: ROUTES.USER_LIST, component: <UserList /> },
  { path: ROUTES.USER_ROLE, component: <RoleList /> },
  { path: ROUTES.USER_PROFILE, component: <Profile /> },

  { path: ROUTES.AI_NEWS, component: <AINewsList /> },
  { path: ROUTES.BOOSTING_NEWS, component: <BoostingNewsList /> },
  { path: ROUTES.GOVERNMENT_IMAGE_BASED_NEWS, component: <ImageBasedNewsList /> },
  { path: ROUTES.GOVERNMENT_LOGO_BASED_NEWS, component: <LogoBasedNewsList /> },
  // { path: ROUTES.REAL_TIME_NEWS, component: <RealTimeNewsList /> },

  { path: ROUTES.MY_NEWS, component: <MyNewsList /> },

  { path: ROUTES.RECOMMEND_REAL_TIME_KEYWORD, component: <RecommendRealTimeKeywordList /> },
  { path: ROUTES.RECOMMEND_POPULAR_KEYWORD, component: <RecommendPopularKeywordList /> },


  { path: ROUTES.AI_ARTICLE_GENERATION, component: <AIArticleGeneration /> },
  { path: ROUTES.IMAGE_REPOSITORY, component: <ImageRepository /> },
  { path: ROUTES.MY_IMAGES, component: <MyImage /> },
  { path: ROUTES.PUBLIC_IMAGES, component: <PublicImage /> },
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: <Navigate to={ROUTES.RECOMMEND_REAL_TIME_KEYWORD} />,
  },
  { path: "*", component: <Navigate to={ROUTES.RECOMMEND_REAL_TIME_KEYWORD} /> },
];

const publicRoutes = [
  // Authentication Page
  // {
  //   path: "/",
  //   exact: true,
  //   component: <HomeLanding />,
  // },
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPasswordPage /> },
  { path: "/register", component: <Register /> },

  //AuthenticationInner pages
  { path: "/pages-coming-soon", component: <ComingSoon /> },
];

export { authProtectedRoutes, publicRoutes, ROUTES };

